export default __webpack_public_path__ + "static/media/a3.d1022b46.png";